/**
 * Función que quita clase wal-drp-phone para que no se interfiera ese telefono
 * Solo de ciertos elementos, de momento de telefonos que tengan data-modal=modal-agent-phone
 */

const deleteClassDRP = async ()=>{
    var elPhoneAgente2 = document.querySelector('.ga-call-header')
    if(elPhoneAgente2!=null){
        const observer = new MutationObserver(()=>{
            const elPhone = document.querySelector('.ga-call-header')
            if(elPhone){
                if (elPhone.hasAttribute('class', 'wal-drp-phone')) {
                    elPhone.classList.remove('wal-drp-phone')
                    elPhone.href = "tel:"+elPhone.textContent;
                    observer.disconnect();
                }
            }
        })
        const config = { 
            childList: true, 
            attributes: true, 
            attributeFilter: ['class'] 
        };
        observer.observe(elPhoneAgente2,config)
    }
   
}


export function removeClassDRP() {
    let timeInterval = 0
    let primerPhoneAgente = ''
    deleteClassDRP();
    const quitarDRPClass = setInterval(() => {
        const elPhoneAgente = document.querySelector('a[data-modal="modal-agent-phone"]')

        if (elPhoneAgente) {
            if (primerPhoneAgente == '') {
                primerPhoneAgente = elPhoneAgente.href
            }

            if (elPhoneAgente.hasAttribute('class', 'wal-drp-phone')) {
                clearInterval(quitarDRPClass)
                elPhoneAgente.classList.remove('wal-drp-phone')
                elPhoneAgente.href = primerPhoneAgente
            }

            if (timeInterval >= 200) {
                clearInterval(quitarDRPClass)
            }

            timeInterval++
        }
    });

    const url = window.location.href;

    if(url.indexOf("origin=AGW") > -1){
      
      let etiquetasConRingpool = document.querySelectorAll(".html-drp-phone", ".wal-drp-phone")
      
      if(etiquetasConRingpool){
        etiquetasConRingpool.forEach((etiqueta)=>{  
          etiqueta.hasAttribute("class","html-drp-phone") ? etiqueta.classList.remove("html-drp-phone") : "";
          etiqueta.hasAttribute("class","wal-drp-phone") ? etiqueta.classList.remove("wal-drp-phone") : "";
        })
      }
      etiquetasConRingpool.forEach((etiqueta)=>{  
        etiqueta.hasAttribute("class","html-drp-phone") ? setTimeout(() => {etiqueta.classList.remove("html-drp-phone")}, 800) : "";
        etiqueta.hasAttribute("class","wal-drp-phone") ? setTimeout(() => {etiqueta.classList.remove("wal-drp-phone")},800) : "";
      })
    }
}